import React from "react";
import { Button, Spinner } from "reactstrap";
import classnames from "classnames";

const ButtonLoading = ({ children, loading, ...rest }) => {
  return (
    <Button {...rest} disabled={loading}>
      {loading && (
        <Spinner
          className={classnames({
            "position-relative": true,
            visible: loading,
            invisible: !loading,
          })}
          size="sm"
        />
      )}
      <span className={`pl-2`}>{children}</span>
    </Button>
  );
};

export default ButtonLoading;
